import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Globe, Copy, ExternalLink, Linkedin, Mail, Twitter, Share2 } from 'lucide-react';
import { toast } from 'sonner';

// The public landing page lives at /request-assessment. We add a `?source=` query
// param so each channel's submissions are tagged in the admin invitations list.
const SOURCES = [
  { id: 'generic', label: 'Generic / Bio Link', icon: Share2, color: 'text-slate-300' },
  { id: 'linkedin', label: 'LinkedIn', icon: Linkedin, color: 'text-[#0A66C2]' },
  { id: 'email', label: 'Email Blast', icon: Mail, color: 'text-[#10B981]' },
  { id: 'twitter', label: 'X / Twitter', icon: Twitter, color: 'text-slate-300' },
];

export const PublicLinkCard = () => {
  const baseUrl = `${window.location.origin}/request-assessment`;

  const copy = async (url, label) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(`${label} link copied to clipboard`);
    } catch {
      toast.error('Could not copy link');
    }
  };

  return (
    <Card className="bg-slate-800/50 border-slate-700" data-testid="public-link-card">
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-white font-semibold flex items-center gap-2">
            <Globe className="h-5 w-5 text-[#10B981]" />
            Public Landing Page
          </h3>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => window.open(baseUrl, '_blank', 'noopener,noreferrer')}
            className="text-slate-400 hover:text-white"
            data-testid="open-public-page-btn"
          >
            <ExternalLink className="h-4 w-4 mr-1" />
            Preview
          </Button>
        </div>
        <p className="text-slate-400 text-sm mb-4">
          Share this link to let prospects request an assessment themselves. Each tag below
          tracks the channel — you'll see the source on every self-requested invitation.
        </p>

        {/* Generic + per-channel links */}
        <div className="space-y-2" data-testid="public-link-list">
          {SOURCES.map(({ id, label, icon: Icon, color }) => {
            const url = id === 'generic' ? baseUrl : `${baseUrl}?source=${id}`;
            return (
              <div
                key={id}
                className="flex items-center gap-3 bg-slate-700/30 rounded-lg p-3"
                data-testid={`public-link-${id}`}
              >
                <Icon className={`h-4 w-4 flex-shrink-0 ${color}`} />
                <div className="flex-1 min-w-0">
                  <p className="text-slate-300 text-xs font-medium">{label}</p>
                  <p className="text-slate-500 text-xs truncate" title={url}>{url}</p>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => copy(url, label)}
                  className="border-slate-600 text-slate-300 hover:bg-slate-700 flex-shrink-0"
                  data-testid={`copy-public-link-${id}`}
                >
                  <Copy className="h-4 w-4 mr-1" />
                  Copy
                </Button>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
